(function () {
  'use strict';

  var config = document.getElementById('openai-ads-config');
  if (!config || window.SleepybellyOpenAIAds || window.oaiq) return;
  var pixelId = config.dataset.pixelId.trim();
  if (!pixelId) return;

  var quantities = Object.create(null);
  var initialized = false;
  var viewed = false;
  var currency = config.dataset.currency;
  config.dataset.cart.split(',').filter(Boolean).forEach(function (line) {
    var parts = line.split(':');
    quantities[parts[0]] = (quantities[parts[0]] || 0) + Number(parts[1]);
  });

  function allowed() {
    try {
      var privacy = window.Shopify.customerPrivacy;
      return privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (_) { return false; }
  }

  function optedOut() {
    try { return window.Shopify.customerPrivacy.saleOfDataAllowed() !== true; }
    catch (_) { return true; }
  }

  function measure(name, data) {
    try {
      if (!initialized || !allowed()) return;
      window.oaiq('measure', name, data, { opt_out: optedOut() });
    } catch (_) {}
  }

  function minorUnits(price) {
    var digits = new Intl.NumberFormat('en', {
      style: 'currency', currency: currency
    }).resolvedOptions().maximumFractionDigits;
    return Math.round(Number(price) / 100 * Math.pow(10, digits));
  }

  function content(item, quantity) {
    var result = {
      id: String(item.variant_id || item.id), content_type: 'product', quantity: quantity
    };
    var price = item.final_price == null ? item.price : item.final_price;
    if (price != null && Number.isFinite(Number(price)) && Number(price) >= 0) {
      result.amount = minorUnits(price);
    }
    return result;
  }

  function added(contents) {
    if (!contents.length) return;
    var data = { type: 'contents', currency: currency, contents: contents };
    if (contents.every(function (item) { return item.amount != null; })) {
      data.amount = contents.reduce(function (sum, item) {
        return sum + item.amount * item.quantity;
      }, 0);
    }
    measure('items_added', data);
  }

  function requestedItems(request) {
    if (typeof request === 'string') {
      if (request.trim().charAt(0) === '{') request = JSON.parse(request);
      else {
        var params = new URLSearchParams(request);
        if (params.has('id')) return [{ id: params.get('id'), quantity: params.get('quantity') || 1 }];
        return [];
      }
    }
    return request.items || [request];
  }

  function cartAdded(response, request) {
    try {
      var items = response.items || [response];
      var requested = requestedItems(request);
      var contents = [];
      requested.forEach(function (entry) {
        var quantity = Number(entry.quantity == null ? 1 : entry.quantity);
        var item = items.find(function (candidate) {
          return String(candidate.variant_id || candidate.id) === String(entry.id);
        });
        if (!item || !Number.isInteger(quantity) || quantity <= 0) return;
        var id = String(entry.id);
        quantities[id] = (quantities[id] || 0) + quantity;
        contents.push(content(item, quantity));
      });
      added(contents);
    } catch (_) {}
  }

  function cartUpdated(cart, reportIncreases) {
    try {
      if (!Array.isArray(cart.items)) return;
      var next = Object.create(null);
      var byId = Object.create(null);
      cart.items.forEach(function (item) {
        var id = String(item.variant_id || item.id);
        next[id] = (next[id] || 0) + item.quantity;
        byId[id] = item;
      });
      var previous = quantities;
      quantities = next;
      currency = cart.currency || currency;
      if (!reportIncreases) return;
      added(Object.keys(next).filter(function (id) {
        return next[id] > (previous[id] || 0);
      }).map(function (id) {
        return content(byId[id], next[id] - (previous[id] || 0));
      }));
    } catch (_) {}
  }

  function syncConsent() {
    try {
      var consent = allowed();
      if (!initialized && consent) {
        if (window.oaiq) return;
        var queue = function () { queue.q.push(arguments); };
        queue.q = [];
        window.oaiq = queue;
        window.oaiq('consent', false);
        window.oaiq('init', { pixelId: pixelId });
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
        document.head.appendChild(script);
        initialized = true;
      }
      if (!initialized) return;
      window.oaiq('consent', consent);
      if (!consent || viewed) return;
      viewed = true;
      measure('page_viewed', { type: 'contents' });
      if (config.dataset.productId) {
        var item = content({ id: config.dataset.productId, price: config.dataset.productPrice }, 1);
        measure('contents_viewed', {
          type: 'contents', currency: currency, amount: item.amount, contents: [item]
        });
      }
    } catch (_) {}
  }

  window.SleepybellyOpenAIAds = { cartAdded: cartAdded, cartUpdated: cartUpdated };
  document.addEventListener('visitorConsentCollected', syncConsent);
  syncConsent();
  try {
    if (!window.Shopify.customerPrivacy) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) syncConsent();
      });
    }
  } catch (_) {}
})();
